import axios from 'axios';
import { Message, getConfiguration } from '../models';

export const getMessages = async (): Promise<Message[]> => {
    const result = await axios(
        `${getConfiguration().serviceEndpoint}/zinutes/message/landing`
    );
    return result.data;
};
